import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";
import {
    OrganizationMicrosoftAccount
} from "../../../../app/integrations/settings/entra/model/organization-microsoft-account";


// const debug = "MicrosoftEntraIDModule"
const debug = false

export class MicrosoftEntraIDModule extends ModuleProto {

    public organizationMicrosoftAccount : OrganizationMicrosoftAccount | null


    constructor() {
        super(ModuleType.MICROSOFT_ENTRA_ID, {});

        debug && console.log(debug, "constructor() moduleConfig=")

        this.name                           = "Microsoft Entra"
        this.description                    = "The GoodDay Microsoft Entra integration allows users to securely log in using their existing Microsoft credentials, simplifying users and access management for your organization."
        this.svgIcon                        = "isvg-microsoft-entra-integration"
        this.settingsMenuTopCategory        = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                      = "Integrations"
        this.settingsUrl                    = "settings/integrations/entra"
        this.parentSection                  = SettingsParentSection.INTEGRATIONS

        this.canDisable                     = false
        this._isEnabled                     = true // because this.canDisable false

        this.organizationMicrosoftAccount   = null

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    // disable = async ()=> {
    //     _.map(this.userMicrosoftAccounts, (login: any)=>{
    //         gd.api.MyAccount.unlinkGoogleAccount(login.googleUserId)
    //     })
    // }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
